// @flow

import * as React from 'react';
import { ExpandMore } from '../../icons/expand-more.js';

const IconExpand = ({ open, duration, size }) => (
  <ExpandMore
    css={{
      transition: `transform ${duration / 1000}s ease-out`,
      transform: open
        ? 'translateY(1px) rotate(180deg)'
        : 'translateY(1px) rotate(0deg)',
    }}
    size={size}
  />
);

type Props = {|
  open: boolean,
  duration?: number,
  size?: number,
|};

export const AnimExpandIcon = ({
  open,
  duration = 300,
  size,
}: Props): React.Node => (
  <IconExpand duration={duration} size={size} open={open} />
);
